import { render } from "./Factories.vue?vue&type=template&id=1d44fcdc&scoped=true&ts=true"
import script from "./Factories.vue?vue&type=script&lang=ts"
export * from "./Factories.vue?vue&type=script&lang=ts"

import "./Factories.vue?vue&type=style&index=0&id=1d44fcdc&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d44fcdc"]])

export default __exports__